const state = {
    readOnly: true
}

const mutations = {
    TOGGLE_EDIT(state, toggle) {
        state.readOnly = toggle ? toggle : !state.readOnly
    }
}

const actions = {
    togglePlanEdit: ({commit}, toggle) => {
        commit('TOGGLE_EDIT', toggle)
    },
}

export default {
    state, mutations, actions
}


// WEBPACK FOOTER //
// ./src/store/backoffice/plansStore.js